<template>
  <div v-if="can('list-service')">
    <h2 class="">Service List</h2>
    <div class="list-table">
      <div class="col-md-12">
        <div class="block-right col-md-2">
          <div class="btn-group float-right" style="margin-bottom: 5px">
            <input
              type="text"
              class="float-right form-control"
              style="margin: 0px"
              placeholder="Search"
              v-model="query"
              v-on:keyup.enter="searchService()"
            />
            <span
              class="fa fa-search btn btn-success"
              style="cursor: pointer"
              v-on:click="searchService()"
            />
          </div>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Title</th>
            <th scope="col">Slug</th>
            <th scope="col">Time Period</th>
            <th scope="col">Image</th>
            <th scope="col">Sort</th>
            <th scope="col">Status</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in serviceList" :key="data.id">
            <td>{{ data.title }}</td>
            <td>{{ data.slug }}</td>
            <td>{{ data.time_period_format }}</td>

            <td>
              <img
                :src="data.image"
                style="width: 50px; height: 50px"
                class="img-fluid"
              />
            </td>
            <td>{{ data.sort }}</td>
            <td v-html="statusHtml(data.status)"></td>

            <td>
              <router-link
                v-if="can('edit-service')"
                class=""
                :to="{
                  name: 'EditService',
                  params: {
                    id: data.id,
                  },
                }"
                ><i class="fa fa-edit text-warning" title="Edit"></i
              ></router-link>

              <i
                style="cursor: pointer"
                title="Delete"
                class="fa ps-3 fa-trash text-danger"
                v-if="can('delete-service') && data.status == 0"
                v-on:click="deleteService(data.id)"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-md-6">
          <select class="form-control" v-model="currentPage">
            <option v-for="i in lastPage" :key="i" :value="i">
              Jump To Page {{ i }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <paginate
            class="block-right"
            containerClass="pagination"
            pageLinkClass="page-link"
            pageClass="page-item"
            prev-text="Prev"
            next-text="Next"
            prev-link-class="page-link"
            next-link-class="page-link"
            :page-count="lastPage"
            :click-handler="paginationClickHandler"
            v-model="currentPage"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "ServiceList",
  components: {},
  data() {
    return {
      serviceList: [],

      lastPage: 1,
      query: "",
      currentPage: 1,
    };
  },
  mounted() {
    // this.isLoading(true);
    // if (this.can("list-service")) {
    this.getServiceList();
    // } else {
    //   this.$router.push({
    //     name: "Dashboard",
    //   });
    // }
  },
  methods: {
    paginationClickHandler(pageNum) {
      this.currentPage = pageNum;
      this.getServiceList();
    },
    searchService() {
      this.currentPage = 1;
      this.getServiceList();
    },
    ...mapMutations({
      isLoading: "loading",
    }),
    getServiceList() {
      this.$http
        .get(`service?page=${this.currentPage}&q=${this.query}`)
        .then((res) => {
          if (res.data.status == 1) {
            this.serviceList = res.data.data.data;
            this.lastPage = res.data.data.last_page;
            this.isLoading(false);
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        });
    },
    deleteService(id) {
      if (
        this.can("delete-service") &&
        confirm("Are you sure you want to delete this service?")
      ) {
        this.$http.delete("service/" + id).then((res) => {
          if (res.data.status == 1) {
            this.$notify({
              group: "notifications",
              title: "Service",
              type: "success",
              text: res.data.message,
            });
            this.getServiceList();
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        });
      }
    },
  },
  watch: {
    currentPage: function () {
      this.getServiceList();
    },
    onPageChange(page) {
      console.log(page);
      this.currentPage = page;
    },
  },
};
</script>
<style>
.block-right {
  float: right !important;
}
</style>
